import { AuthContext } from '@f_context/Auth_context';
import { GeneralContext } from '@f_context/General_context';
import { ThemeContext } from '@f_context/Theme_context';
import { UserContext } from '@f_context/User_context';
import { QwepContext } from '@f_qwep/context/Qwep_context';
import { useMigratedUserLock } from '@f_hooks/useMigratedUserLock';
import stls from '@f_styles/components/licenses/Licenses.module.sass';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import { Alert, Box, Card, CardContent, Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
export function Subscription() {
    const { colors } = useContext(ThemeContext);
    const { drawerPanels } = useContext(GeneralContext);
    const { isMigratedLocked } = useMigratedUserLock(drawerPanels);
    const { blocked } = useContext(QwepContext);
    const { accountInfo } = useContext(AuthContext);
    const { activeApp } = useContext(QwepContext);
    const { userRole } = useContext(UserContext);
    const [show, setShow] = useState(false);

    useEffect(() => {
        const isSuperAdmin = userRole.some((item) => item.includes('SUPER_ADMIN') || item.includes('admin'));
        const createBy = accountInfo?.user?.createBy === 0 || accountInfo?.user?.createBy === null;
        if (createBy && activeApp && isSuperAdmin) {
            setShow(true);
        } else {
            setShow(false);
        }
    }, [accountInfo, activeApp, userRole]);

    if (isMigratedLocked || blocked) {
        return null;
    }

    return (
        <Box className={stls.subscriptionBox}>
            <div style={{ marginTop: '56px', marginBottom: '32px' }}>
                <Card
                    sx={{
                        background: `linear-gradient(135deg, ${colors.psi} 0%, ${colors.omega} 100%)`,
                        border: `2px solid ${colors.alpha}`,
                        borderRadius: 3,
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
                        overflow: 'visible',
                        position: 'relative',
                        maxWidth: '740px',
                    }}>
                    <CardContent sx={{ p: 4 }}>
                        <Box
                            sx={{
                                position: 'absolute',
                                top: -40,
                                left: 40,
                                background: colors.alpha,
                                borderRadius: '50%',
                                width: 100,
                                height: 100,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                            }}>
                            <WarningIcon sx={{ color: '#fff', fontSize: 40 }} />
                        </Box>

                        <Typography
                            variant="h4"
                            sx={{
                                color: colors.alpha,
                                fontWeight: 'bold',
                                mb: 3,
                                mt: 3,
                                textAlign: 'center',
                            }}>
                            Доступна миграция на новую версию системы
                        </Typography>

                        <Alert
                            severity="info"
                            icon={<InfoIcon />}
                            sx={{
                                mb: 3,
                                background: `rgba(33, 150, 243, 0.1)`,
                                border: `1px solid rgba(33, 150, 243, 0.3)`,
                                '& .MuiAlert-message': {
                                    color: colors.omicron,
                                },
                            }}>
                            <Typography variant="h6" sx={{ margin: '16px 0 0 0', color: colors.lambda }}>
                                В данный момент поддержка продления старой системы не осуществляется.
                            </Typography>
                            {show && (
                                <Typography variant="h6" sx={{ margin: '16px 0 0 0', color: colors.lambda }}>
                                    Рекомендуем перейти на новую версию системы, через миграцию вашего аккаунта.
                                    <br />
                                    Для этого создайте миграцию кликнув по кнопке в верхнем правом углу и следуйте
                                    инструкциям.
                                    <br />
                                </Typography>
                            )}
                        </Alert>
                    </CardContent>
                </Card>
            </div>
        </Box>
    );
}
